export const body = {
    paddingTop: "20px",
    paddingRight: "30px"
};

export const layoutContainer = {
    display: "flex",
    alignItems: "center",
    columnGap: "5px"
};

export const columnRight = {
    textAlign: "right"
};
